module.exports = __webpack_public_path__ + "img/soccerboard124.34e18f43.jpg";